import createIcon from '../../createIcon';

/**
 * @component @name PropaneTank
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxNVYxOEM0IDIwLjIxIDUuNzkgMjIgOCAyMkgxNkMxOC4yMSAyMiAyMCAyMC4yMSAyMCAxOFYxNUg0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwIDEzVjEwQzIwIDguMTQgMTguNzIgNi41OSAxNyA2LjE0VjRDMTcgMi45IDE2LjEgMiAxNSAySDlDNy45IDIgNyAyLjkgNyA0VjYuMTRDNS4yOCA2LjU5IDQgOC4xNCA0IDEwVjEzSDIwWk05IDRIMTVWNkgxM0MxMyA1LjQ1IDEyLjU1IDUgMTIgNUMxMS40NSA1IDExIDUuNDUgMTEgNkg5VjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PropaneTank = createIcon('PropaneTank', [
  ['path', { d: 'M4 15V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V15H4Z', key: 'hq2dpl' }],
  [
    'path',
    {
      d: 'M20 13V10C20 8.14 18.72 6.59 17 6.14V4C17 2.9 16.1 2 15 2H9C7.9 2 7 2.9 7 4V6.14C5.28 6.59 4 8.14 4 10V13H20ZM9 4H15V6H13C13 5.45 12.55 5 12 5C11.45 5 11 5.45 11 6H9V4Z',
      key: 'sghqnu',
    },
  ],
]);

export default PropaneTank;
